import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IAppRegion } from '~/lib/appSettings';
import type { IApiGetInvitationResponseBody } from '../InvitationsApi.types';
import { useApi } from '~/lib/api/useApi';
import { invitationQueryKeyFactory } from './useInvitationQuery';

export type IUsePublicInvitationQueryValues = {
  invitationId: string;
  appRegion: IAppRegion;
};

export const publicInvitationQueryKeyFactory: IQueryKeyFactory<
  IUsePublicInvitationQueryValues
> = (values) =>
  values && (['invitations', values.appRegion, values.invitationId] as const);

export const usePublicInvitationQuery = (
  values?: IUsePublicInvitationQueryValues,
  options?: UseQueryOptions<IApiGetInvitationResponseBody, ApiError>,
): UseQueryResult<IApiGetInvitationResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: invitationQueryKeyFactory(values),
    queryFn: values
      ? () => api.invitations.getPublic(values.invitationId, values.appRegion)
      : undefined,
    enabled: !!values,
    ...options,
  });
};
